<template>
  <div class="autocompletado">
    <input
      ref="input"
      type="text"
      :class="inputClass"
      :placeholder="textoPlaceHolder"
      v-model="nombre"
      @keydown.up="up"
      @keydown.down="down"
      @keydown.enter="selectItem"
      @blur="limpiarBusqueda"
    />
    <div class="options" ref="optionsList" v-if="items.length > 0 && nombre.length > 2 && visible">
      <ul>
        <li
          v-for="(item, index) in items"
          :key="index"
          :class="{ selected: selected == index }"
          @click="itemClicked(index)"
        >{{item.nombre}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import ApiBuscador from "@/services/ApiBuscador";
export default {
  name: "Autocompletado",
  props: {
    shouldReset: {
      type: Boolean,
      default: true
    },
    nombreCarrera: {
      type: String,
      default: "",
      required: true
    },
    matches: { type: Array, default: () => [] },
    textoPlaceHolder: {
      type: String,
      default: "Nombre"
    },
    inputClass: {
      type: String,
      default: "w-100 form-control rounded-0 py-1"
    }
  },
  data() {
    return {
      nombre: "",
      //items: [],
      itemHeight: 39,
      selected: -1,
      visible: false,
      selectedItem: ""
    };
  },
  watch: {
    nombre(val) {
      this.buscarPorNombre(val);
    },
    nombreCarrera(val) {
      this.nombre = val;
      this.toggleVisible();
    }
  },
  computed: {
    items() {
      if (this.matches) {
        if (this.nombre === "") {
          return [];
        }
        return this.matches;
      }
    }
  },
  methods: {
    async buscarPorNombre(val) {
      if (val.length > 2 && this.selectedItem === "") {
        this.visible = true;
        this.$emit("change", val);
      }
      if (val.length === 0) {
        this.selectedItem = "";
      }
    },
    toggleVisible() {
      setTimeout(() => {
        this.$refs.input.focus();
        //this.visible = !this.visible;
        this.visible = false;
      }, 200);
    },
    itemClicked(index) {
      this.$emit("busquedaExacta", true);
      this.selected = index;
      this.selectItem();
    },
    selectItem() {
      if (!this.items.length) {
        return;
      }
      this.selectedItem = this.items[this.selected];
      this.visible = false;
      if (this.shouldReset) {
        if (this.selected > -1) {
          this.nombre = this.selectedItem.nombre;
          this.$emit("busquedaExacta", true);
        }
        this.selected = -1;
        //this.items = [];
      }
      this.$emit("selected", JSON.parse(JSON.stringify(this.nombre)));
    },
    limpiarBusqueda() {
      setTimeout(
        () => (
          (this.selectedItem = ""), (this.selected = -1), (this.visible = false)
        ),
        300
      );
      this.$emit("asignarTextoIncompleto", this.nombre);
    },
    up() {
      if (this.selected == -1) {
        return;
      }
      this.selected -= 1;
      this.scrollToItem();
    },
    down() {
      if (this.selected >= this.items.length - 1) {
        return;
      }
      this.selected += 1;
      this.scrollToItem();
    },
    scrollToItem() {
      this.$refs.optionsList.scrollTop = this.selected * this.itemHeight;
    }
  }
};
</script>

<style>
.close {
  position: absolute;
  right: 10px;
  top: 3px;
  background: none;
  border: none;
  font-size: 30px;
  color: lightgrey;
  cursor: pointer;
}
.autocompletado {
  background: #fff;
  border-radius: 3px;
  width: 100%;
}
.options {
  position: absolute;
  z-index: 999 !important;
  background: #fff;
  max-height: 150px;
  overflow-y: scroll;
  border: solid 1px #555;
  width: 100%;
}
.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}
.options ul li {
  border-bottom: 1px solid #e5f1f9;
  padding: 10px;
  cursor: pointer;
  background: #fff;
}
.options ul li:first-child {
  border-top: 2px solid #d6d6d6;
}
.options ul li:not(.selected):hover {
  background: #e5f1f9;
  color: #245ea3;
}
.options ul li.selected {
  background: #5982ba;
  color: #fff;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/generales/Autocompletado.vue